import { FC } from "react";

export interface AdvisorAskInputProps {
  placeholder: string;
  buttonText: string;
  onClick: () => void;
  className?: string;
}

export const AdvisorAskInput: FC<AdvisorAskInputProps> = ({
  placeholder,
  buttonText,
  onClick,
  className = "",
}) => {
  return (
    <button
      onClick={onClick}
      className={`flex w-full items-center rounded-full bg-white p-1 ${className}`}
    >
      <span className="flex-1 pl-4 text-left font-sans text-sm font-normal leading-[18px] text-[rgba(0,0,0,0.34)]">
        {placeholder}
      </span>

      <div className="rounded-full bg-[#BDA280] px-6 py-3 font-sans text-xs font-bold uppercase leading-[18px] text-white">
        {buttonText}
      </div>
    </button>
  );
};
